// extracted by css-extract-rspack-plugin
var _1 = "M74AmHsMmp4MxAwT";
export { _1 as "liveRegion" }
// extracted by css-extract-rspack-plugin
var _1 = "M74AmHsMmp4MxAwT";
export { _1 as "liveRegion" }
